import {Component, ElementRef, OnInit, OnDestroy, AfterViewInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Agency} from "../Models/Agency";
import {AppComponent} from "../app.component";
import {Adresse} from "../Models/Adresse";
import {GoogleMap} from '@angular/google-maps';
//import {EmailRegex, PhoneFrRegex} from "../const/utils";

@Component({
	selector: 'app-modal-add-agency',
	templateUrl: './modal-add-agency.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./modal-add-agency.component.less']
})
export class ModalAddAgencyComponent implements OnInit, AfterViewInit {
	@ViewChild('searchAdr') searchElementRef!: ElementRef;
	@ViewChild(GoogleMap) map!: GoogleMap;

	globalTxt: any;
	modalsTxt: any;
	modalInfo: any;
	submitted = false;
	agencyForm!: FormGroup;
	agency: any;
	//agents: Agent[] = Agent.agents;
	adresse!: Adresse;
	userId: any = localStorage.getItem('user_id');
	userRole: any = localStorage.getItem('user_role');
	form_created: boolean = false;

	constructor(
		public app: AppComponent,
		private formBuilder: FormBuilder,
	) {
	}

	get f() {
		return this.agencyForm.controls;
	}

	ngAfterViewInit(): void {
		// Initialize the Google address input
		setTimeout(() => {
			this.app.sharedToolsService.googleAddressToAdresse(this.searchElementRef, this.agencyForm, this.adresse);
		}, 1000);
	}

	ngOnInit(): void {
		this.app.dataToolsService.currentModalInfo.subscribe(modalInfo => {
			console.log("modalInfo  => ", modalInfo);
			this.modalInfo = modalInfo;
		});

		this.getInfosInit();
	}

	getInfosInit() {
		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			// Get the modal texts
			this.app.dataInitService.getModalTextsForModalComponentOnce(modalsTxt => {
				this.modalsTxt = modalsTxt.addAgency;

				let modalData = JSON.parse(localStorage.getItem('modalOpen')!);

				if (modalData?.data?.id != -1) { // It's an edition: We retrieve the data by ID.
					this.getOrganisationById(modalData.data.id);

				} else { // It's an addition: We create a new form and add the correct role.
					this.adresse = new Adresse();
					this.createForm(null);
				}
			});
		});
	}

	getOrganisationById(id: number) {
		this.app.apiToolsService.getOrganisationById(id).subscribe((res: any) => {
			this.agency = res;

			// Create the address
			this.adresse = (this.agency.ADR_ID)
				? new Adresse(this.agency.ADR_ID, null, this.agency.ADR_ADRESSE_1, this.agency.ADR_CP, this.agency.ADR_VILLE, this.agency.PYS_CODE)
				: new Adresse();

			// Create the form
			this.createForm(this.agency);
		})
	}

	onChangeFranchise(event: any) {
		if (event.target.checked) {
			this.agencyForm.get('ORG_TYPE')?.setValue(2);
		} else {
			this.agencyForm.get('ORG_TYPE')?.setValue(1);
		}
		// console.log("event ==> ", event);
		// console.log("this.agencyForm.get('type') ==> ", this.agencyForm.get('type')?.value);
	}

	createForm(_agency: any) {
		const controls: { [key: string]: any[] } = {
			ORG_ID: [_agency ? this.agency?.ORG_ID : -1],
			ORG_LIBELLE: [_agency ? this.agency?.ORG_LIBELLE : '', [Validators.required]],
			ORG_DESC: [_agency ? this.agency?.ORG_DESC : '', []],
			isFranchise: [_agency ? this.agency.ORG_TYPE == 2 : false],
			ORG_TYPE: [_agency ? this.agency?.ORG_TYPE : 1],
			ORG_SIMU_TOTAL: [_agency ? this.agency?.ORG_SIMU_TOTAL : 0],
			ORG_SIMU_USED: [_agency ? this.agency?.ORG_SIMU_USED : 0],
			adresseComplete: [_agency && _agency.ADR_ID ? this.app.sharedToolsService.formatOriginalAdr(this.adresse) : '', []],
			ORG_ADR: [this.adresse],
			//agents: [_agency ? this.agency?.agents : []],
		};

		this.agencyForm = this.formBuilder.group(controls);

		// Add adresseValidator
		this.agencyForm.get('adresseComplete')?.valueChanges.subscribe((value) => {
			console.log("value ==> ", value);
			const adrControl = this.agencyForm.get('ORG_ADR');
			this.app.sharedToolsService.updateValidatorsAdrComplete(value, adrControl, this.adresse);
		});

		// Disable the SIMU fields
		this.agencyForm.get('ORG_SIMU_TOTAL')?.disable();
		this.agencyForm.get('ORG_SIMU_USED')?.disable();

		console.log("this.agencyForm ==> ", this.agencyForm);

		// Set the form created to true
		this.form_created = true;
	}

	onSubmit() {
		console.log("this.agencyForm ==> ", this.agencyForm);
		console.log("this.agencyForm.value ==> ", this.agencyForm.value);

		// ==> Replace the address values
		let org: Agency = this.agencyForm.value;
		org.ADR_ID = org.ORG_ADR.ADR_ID || -1;
		org.ADR_ADRESSE_1 = org.ORG_ADR.ADR_ADRESSE_1;
		org.ADR_CP = org.ORG_ADR.ADR_CP;
		org.ADR_VILLE = org.ORG_ADR.ADR_VILLE;
		org.PYS_CODE = org.ORG_ADR.PYS_CODE;

		// Delete keys
		delete org.ORG_ADR;
		delete org.adresseComplete;
		delete org.isFranchise;

		console.log("onSubmit FCT org == >", org);

		this.submitted = true;

		if (this.agencyForm.invalid) {
			// ==> Show errorMessage
			console.log("Erreur dans le formulaire agencyForm");
			return;
		} else {
			console.log("Le formulaire est valide");
			// ==> Save the agency
			this.setOrEditAgency(org);

			// ==> Close the modal
			//this.app.sharedToolsService.closeModal(this.modalInfo);
		}
	}

	setOrEditAgency(_org: Agency) {
		console.log("setOrEditAgency ==> ", _org);
		this.app.apiToolsService.setOrganisation(_org).subscribe((res: any) => {
			console.log("setOrEditAgency ==> ", res);

			this.app.confirmDialogService.confirmThis(
				"", //title
				this.modalsTxt.modalSuccessAddOrEditOrg, "alert", "",
				() => {
					location.reload();
				},
				() => {
				});

		})
	}
}
